import List from './actions/list';
import Find from './actions/find';
import Create from './actions/create';
import Delete from './actions/delete';
import Resource from './resource';

export default class Export extends Resource {
  get resourceName() {
    return 'export';
  }

  get resourcesName() {
    return 'exports';
  }
}
// @ts-ignore
List.includeInto(Export);
// @ts-ignore
Find.includeInto(Export);
// @ts-ignore
Create.includeInto(Export);
// @ts-ignore
Delete.includeInto(Export);
